import React from "react";
import BarChart from "../../core/charts/BarChart";

const ScrollBarChart = (props) => {
	return <BarChart {...props} />;
};

export default ScrollBarChart;
